import { render, staticRenderFns } from "./ResolvedPetitions.vue?vue&type=template&id=5f33b7b2"
import script from "./ResolvedPetitions.vue?vue&type=script&lang=js"
export * from "./ResolvedPetitions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports